export default "__VITE_ASSET__CcsIMdc___"